import React from 'react'
import CircularProgress from '@mui/material/CircularProgress';
import {Fade, Paper} from '@mui/material';

function RandomImage({image, isThereAnImage, isLoading, imageLoaded}){

    
    return (
        <>
        {isThereAnImage ? (
            <>
            <Fade in={isLoading} timeout={500}>
              <div className='loader'>
                <CircularProgress/>
              </div>
              </Fade>
              <Fade in={!isLoading} timeout={500}>
              <img
                src={image}
                alt="reference"
                style={{ maxWidth: "100%", maxHeight: "100%" }}
                onLoad={() => {
                  imageLoaded();
                }}
              />
              </Fade>
            </>
          ) : (
            <Paper elevation={0} style={{ padding: "10px" }}>
              <p>We ran out of images, ending session...</p>
            </Paper>
          )}
          </>
    )
}

export default RandomImage
